// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BackToTopController from "./back_to_top_controller"
application.register("back-to-top", BackToTopController)

import BookmarkletController from "./bookmarklet_controller"
application.register("bookmarklet", BookmarkletController)

import ConfirmationController from "./confirmation_controller"
application.register("confirmation", ConfirmationController)

import PageInfoController from "./page_info_controller"
application.register("page-info", PageInfoController)

import SlideFetcherController from "./slide_fetcher_controller"
application.register("slide-fetcher", SlideFetcherController)

import SlideFooterController from "./slide_footer_controller"
application.register("slide-footer", SlideFooterController)

import SlideImageController from "./slide_image_controller"
application.register("slide-image", SlideImageController)

import SlideImagesController from "./slide_images_controller"
application.register("slide-images", SlideImagesController)

import UrlFormController from "./url_form_controller"
application.register("url-form", UrlFormController)
